var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('Medical',{staticClass:"px-360",staticStyle:{"margin-top":"80px"},attrs:{"bg":_vm.background}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }